<template>
  <div>
    <Header></Header>
    <div id="main">
      <div class="container">
        <div class="row">
          <b-tabs>
            <b-tab title="Meu Perfil" :active="configActive" class="form-config">
              <FormProfile v-bind:user="user" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="loadProfile()"></FormProfile>
            </b-tab>
            <b-tab v-if="user && user.isPartner" title="Dados de Loja" :active="partnerActive" class="form-partner">
              <FormPartner v-bind:user="user" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="loadProfile()"></FormPartner>
            </b-tab>
            <b-tab v-if="user && user.isPartner" title="Campanhas" :active="campaignActive" class="form-campaign">
              <FormPartnerCampaign v-bind:user="user" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="loadProfile()"></FormPartnerCampaign>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import Loading from './includes/Loading'
import auth from '../services/auth'
import Functions from '../utils/functions'
import { API } from '../services/api'
import FormProfile from './profile/FormProfile'
import FormPartner from './profile/FormPartner'
import FormPartnerCampaign from './profile/FormPartnerCampaign'

export default {
  name: 'Profile',
  components: {
    Header,
    Footer,
    Loading,
    FormProfile,
    FormPartner,
    FormPartnerCampaign
  },
  data () {
    return {
      loading: true,
      user: false,
      configActive: true,
      partnerActive: false,
      campaignActive: false
    }
  },
  created (){
    this.loadProfile();
    if(this.$route.query.tab && this.$route.query.tab == 'campaigns'){
      this.configActive = false;
      this.partnerActive = false;
      this.campaignActive = true;
    }
  },
  methods: {
    loadProfile(){
      this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((response) => {
        this.user = response.body.user;
        this.loading = false;
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  h4{
    color: #00AE39;
    margin-bottom: 1px;
  }
  span{
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue